import { useState, useEffect } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';

import { Container, Row, Col } from 'shards-react';

import MainSidebar from './components/layout/MainSidebar/MainSidebar';
import MainNavbar from './components/layout/MainNavbar/MainNavbar';
import ListOpuUser from './views/opu-user/ListOpuUser/ListOpuUser';
import ListActionLogs from './views/action-log/listActionLogs/ListActionLogs';
import AddOpuUser from './views/opu-user/AddOpuUser/AddOpuUser';
import UpdateOpuUser from './views/opu-user/UpdateOpuUser/UpdateOpuUser';
import ListStudent from './views/student/ListStudent/ListStudent';
import AddStudent from './views/student/AddStudent/AddStudent';
import UpdateStudent from './views/student/UpdateStudent/UpdateStudent';
import ListEstablishmentUser from './views/establishmentUser/ListEstablishmentUser/ListEstablishmentUser';
import AddEstablishmentUser from './views/establishmentUser/AddEstablishmentUser/AddEstablishmentUser';
import UpdateEstablishmentUser from './views/establishmentUser/UpdateEstablishmentUser/UpdateEstablishmentUser';
import AddEstablishment from './views/establishment/addEstablishment/AddEstablishment';
import UpdateEstablishment from './views/establishment/UpdateEstablishment/UpdateEstablishment';
import ListEstablishment from './views/establishment/ListEstablishment/ListEstablishment';
import Loading from './components/UI/loading';
import ListBook from './views/book/ListBook/ListBook';
import AddBook from './views/book/AddBook/AddBook';
import UpdateBook from './views/book/UpdateBook/UpdateBook';
import ListContract from './views/contract/listContract/ListContract';
import AddContract from './views/contract/addContract/addContract';
import UpdateContract from './views/contract/updateContract/updateContract';
import Dashboard from './views/dashboard/dashboard';
import ViewBook from './views/book/ViewBook/ViewBook';
import UserProfile from './views/user-profile/UserProfile';
import DetailsBook from './views/book/DetailsBook/DetailsBook';
import ListAuthor from './views/author/ListAuthor/ListAuthor';
import { auth } from './firebase-init';
import AddAuthor from './views/author/AddAuthor/AddAuthor';
import UpdateAuthor from './views/author/UpdateAuthor/UpdateAuthor';
import ContractInvoicePdf from './views/contract/ContractInvoicePdf';
import { EstablishmentContracts } from './views/contract/listContractByEstablishment';
import ListContractEstablishmentUser from './views/contract/listContract/ListContractEStablishmentUser';
const AppRoutes = (props) => {
  const { auth_user } = props;

  const [role, setRole] = useState(null);
  const [idEstablishment, setIdEstablishment] = useState(null);
  const [userEstablishmentId, setUserEstablishmentId] = useState(null);

  const getToken = async () => {
    if (auth_user) {
      const token = await auth_user.getIdTokenResult();
      console.log({ claims: token });
      setRole(token.claims.role);
      setUserEstablishmentId(token.claims.id);
      setIdEstablishment(token.claims.establishmentId);
    }
  };

  useEffect(() => {
    console.log({ auth_user });
    getToken();
  }, [auth_user]);

  const routesGuard = (role) => {
    let guardedRoutes = [
      <Route exact path="/">
        <Redirect to="/dashboard" />
      </Route>,
      <Route exact path="/user-profile">
        <UserProfile />
      </Route>,
    ];

    switch (role) {
      case 'super_admin':
        guardedRoutes.push(
          <Route exact path="/dashboard">
            <Dashboard />
          </Route>,
          <Route exact path="/opu-user">
            <ListOpuUser displayOptions={{ addButton: true, editAction: true, deleteAction: true }} />
          </Route>,
          <Route exact path="/opu-user/add">
            <AddOpuUser />
          </Route>,
          <Route exact path="/opu-user/update">
            <UpdateOpuUser />
          </Route>,

          <Route exact path="/action-log">
            <ListActionLogs displayOptions={{ addButton: true, editAction: true, deleteAction: true }} />
          </Route>,

          <Route exact path="/establishment-user">
            <ListEstablishmentUser displayOptions={{ addButton: true, editAction: true, deleteAction: true }} />
          </Route>,
          <Route exact path="/establishment-user/add">
            <AddEstablishmentUser />
          </Route>,
          <Route exact path="/establishment-user/update">
            <UpdateEstablishmentUser />
          </Route>,

          <Route exact path="/student">
            {/* <ListStudent displayOptions={{ addButton: true, editAction: true, deleteAction: true, searchEstablishment: true }} /> */}
            <ListStudent
              displayOptions={{
                addButton: true,
                editAction: true,
                deleteAction: true,
                searchEstablishment: true,
                bulkAction: true,
              }}
            />
          </Route>,
          <Route exact path="/student/add">
            <AddStudent role={role} />
          </Route>,
          <Route exact path="/student/update">
            <UpdateStudent role={role} />
          </Route>,

          <Route exact path="/establishment">
            <ListEstablishment displayOptions={{ addButton: true, editAction: true, deleteAction: true }} />
          </Route>,
          <Route exact path="/establishment/add">
            <AddEstablishment />
          </Route>,
          <Route exact path="/establishment/update">
            <UpdateEstablishment />
          </Route>,

          <Route exact path="/establishment">
            <ListEstablishment displayOptions={{ addButton: true, editAction: true, deleteAction: true }} />
          </Route>,
          <Route exact path="/establishment/add">
            <AddEstablishment />
          </Route>,
          <Route exact path="/establishment/update">
            <UpdateEstablishment />
          </Route>,

          <Route exact path="/book">
            <ListBook displayOptions={{ addButton: true, editAction: true, deleteAction: true, viewAction: true }} />
          </Route>,
          <Route exact path="/book/add">
            <AddBook />
          </Route>,
          <Route exact path="/book/update">
            <UpdateBook />
          </Route>,
          <Route exact path="/book/details">
            <DetailsBook />
          </Route>,
          <Route exact path="/book/view">
            <ViewBook />
          </Route>,

          <Route exact path="/contract">
            <ListContract displayOptions={{ addButton: true, editAction: true, deleteAction: true }} />
          </Route>,
          // <Route exact path="/contract/establishment/:establishmentId/:region">
          //   <EstablishmentContracts />
          // </Route>,
          <Route exact path="/contract/add">
            <AddContract />
          </Route>,
          <Route exact path="/contract/update">
            <UpdateContract />
          </Route>,

          <Route exact path="/author">
            <ListAuthor displayOptions={{ addButton: true, editAction: true, deleteAction: true }} />
          </Route>,
          <Route exact path="/author/add">
            <AddAuthor />
          </Route>,
          <Route exact path="/author/update">
            <UpdateAuthor />
          </Route>,
          <Route exact path="/invoice" component={ContractInvoicePdf} />
        );
        break;

      case 'admin':
        guardedRoutes.push(
          <Route exact path="/dashboard">
            <Dashboard />
          </Route>,
          <Route exact path="/establishment-user">
            <ListEstablishmentUser displayOptions={{ addButton: false, editAction: false, deleteAction: false }} />
          </Route>,
          <Route exact path="/establishment-user/add">
            <AddEstablishmentUser />
          </Route>,
          <Route exact path="/establishment-user/update">
            <UpdateEstablishmentUser />
          </Route>,

          <Route exact path="/student">
            <ListStudent
              displayOptions={{
                addButton: false,
                editAction: false,
                deleteAction: false,
                searchEstablishment: true,
                bulkAction: true,
              }}
            />
          </Route>,

          <Route exact path="/establishment">
            <ListEstablishment displayOptions={{ addButton: false, editAction: false, deleteAction: false }} />
          </Route>,
          <Route exact path="/establishment/add">
            <AddEstablishment />
          </Route>,
          <Route exact path="/establishment/update">
            <UpdateEstablishment />
          </Route>,

          <Route exact path="/book">
            <ListBook displayOptions={{ addButton: true, editAction: true, deleteAction: true, viewAction: true }} />
          </Route>,
          <Route exact path="/book/add">
            <AddBook />
          </Route>,
          <Route exact path="/book/update">
            <UpdateBook />
          </Route>,
          <Route exact path="/book/details">
            <DetailsBook />
          </Route>,
          <Route exact path="/book/view">
            <ViewBook />
          </Route>,

          <Route exact path="/contract">
            <ListContract displayOptions={{ addButton: false, editAction: false, deleteAction: false }} />
          </Route>,
          <Route exact path="/contract/add">
            <AddContract />
          </Route>,
          <Route exact path="/contract/update">
            <UpdateContract />
          </Route>,

          <Route exact path="/author">
            <ListAuthor displayOptions={{ addButton: true, editAction: true, deleteAction: true }} />
          </Route>,
          <Route exact path="/author/add">
            <AddAuthor />
          </Route>,
          <Route exact path="/author/update">
            <UpdateAuthor />
          </Route>
        );

        break;

      case 'commercial_admin':
        guardedRoutes.push(
          <Route exact path="/dashboard">
            <Dashboard />
          </Route>,
          <Route exact path="/establishment-user">
            <ListEstablishmentUser displayOptions={{ addButton: true, editAction: true, deleteAction: true }} />
          </Route>,
          <Route exact path="/establishment-user/add">
            <AddEstablishmentUser />
          </Route>,
          <Route exact path="/establishment-user/update">
            <UpdateEstablishmentUser />
          </Route>,

          <Route exact path="/student">
            <ListStudent displayOptions={{ addButton: false, editAction: false, deleteAction: false, bulkAction: true }} />
          </Route>,

          <Route exact path="/establishment">
            <ListEstablishment displayOptions={{ addButton: true, editAction: true, deleteAction: true }} />
          </Route>,
          <Route exact path="/establishment/add">
            <AddEstablishment />
          </Route>,
          <Route exact path="/establishment/update">
            <UpdateEstablishment />
          </Route>,

          <Route exact path="/book">
            <ListBook displayOptions={{ addButton: false, editAction: false, deleteAction: false, viewAction: true }} />
          </Route>,
          <Route exact path="/book/details">
            <DetailsBook />
          </Route>,
          <Route exact path="/book/view">
            <ViewBook />
          </Route>,

          <Route exact path="/contract">
            <ListContract displayOptions={{ addButton: true, editAction: true, deleteAction: true }} />
          </Route>,
          <Route exact path="/contract/add">
            <AddContract />
          </Route>,
          <Route exact path="/contract/update">
            <UpdateContract />
          </Route>,

          <Route exact path="/author">
            <ListAuthor displayOptions={{ addButton: false, editAction: false, deleteAction: false }} />
          </Route>
        );

        break;

      case 'ESTABLISHMENT_USER':
        guardedRoutes.push(
          <Route exact path="/dashboard">
            <Dashboard establishmentUser />
          </Route>,

          <Route exact path="/student">
            <ListStudent
              displayOptions={{
                addButton: true,
                editAction: true,
                deleteAction: true,
                searchEstablishment: false,
                bulkAction: true,
              }}
            />
          </Route>,
          <Route exact path="/student/add">
            <AddStudent role={role} />
          </Route>,
          <Route exact path="/student/update">
            <UpdateStudent role={role} />
          </Route>,
          <Route exact path="/book">
            <ListBook displayOptions={{ addButton: false, editAction: false, deleteAction: false, viewAction: true }} />
          </Route>,
          <Route exact path="/book/details">
            <DetailsBook />
          </Route>,
          <Route exact path="/book/view">
            <ViewBook />
          </Route>,
          <Route exact path="/contract">
            {/* <ListContract displayOptions={{ addButton: false, editAction: false, deleteAction: false }} /> */}
            {/* EstablishmentContracts */}

            <ListContractEstablishmentUser
              userEstablishmentId={userEstablishmentId}
              displayOptions={{ addButton: false, editAction: false, deleteAction: false }}
            />
          </Route>
        );
        break;

      default:
        break;
    }

    return guardedRoutes;
  };

  return (
    <Container fluid>
      {role ? (
        <Row>
          <MainSidebar role={role} idEstablishment={idEstablishment} />
          <Col className="main-content p-0" lg={{ size: 10, offset: 2 }} md={{ size: 9, offset: 3 }} sm="12" tag="main">
            <MainNavbar />
            <Switch>{routesGuard(role)}</Switch>
            {/*<MainFooter />*/}
          </Col>
        </Row>
      ) : (
        <Loading />
      )}
    </Container>
  );
};

export default AppRoutes;
